import SchoolNavIcon from './school'
import MedicalNavIcon from './medical'
import ChemicalNavIcon from './chemical-industrial'
import CoalNavIcon from './coal-mine'
import EnterpriseNavIcon from './enterprise-basic-information'
import GasNavIcon from './gas-station'
import AccommodationNavIcon from './provide-accommodation'
import CultureNavIcon from './public_culture'
import ReligionNavIcon from './religion'
import TupermarketNavIcon from './supermarket'
import TouristNavIcon from './tourist-attractions'
import DefaultNavIcon from './default'
import JzwzcbkIcon from './jzwzcbk'
import ShzzjznlIcon from './shzzjznl'
import SlxfdwyzbIcon from './slxfdwyzb'
import SqxzcjznlIcon from './sqxzcjznl'
import XzjdjznlIcon from './xzjdjznl'
import YjbnsIcon from './yjbns'
import ZfzrzhglnlIcon from './zfzrzhglnl'
import ZfzzhqsyzzIcon from './zfzzhqsyzz'
import yjsjIcon from './yjsj'

export {
  SchoolNavIcon,
  MedicalNavIcon,
  ChemicalNavIcon,
  CoalNavIcon,
  EnterpriseNavIcon,
  GasNavIcon,
  AccommodationNavIcon,
  CultureNavIcon,
  ReligionNavIcon,
  TupermarketNavIcon,
  TouristNavIcon,
  DefaultNavIcon,
  JzwzcbkIcon,
}

const MapNavIcons = {
  SchoolNavIcon,
  MedicalNavIcon,
  ChemicalNavIcon,
  CoalNavIcon,
  EnterpriseNavIcon,
  GasNavIcon,
  AccommodationNavIcon,
  CultureNavIcon,
  ReligionNavIcon,
  TupermarketNavIcon,
  TouristNavIcon,
  DefaultNavIcon,
  JzwzcbkIcon,
  ShzzjznlIcon,
  SlxfdwyzbIcon,
  SqxzcjznlIcon,
  XzjdjznlIcon,
  YjbnsIcon,
  ZfzrzhglnlIcon,
  ZfzzhqsyzzIcon,
  yjsjIcon,
}
export default MapNavIcons
